import compact from './helpers/compact'

export const tw = (...classes: string[]) => {
    return compact(classes).join(' ').trim().replace(/\s+/g,' ')
}